<template>
    <div>
        <v-table
            :headers="headers"
            :items="this.$store.getters.id_snvs"
            :items-per-page="5"
            item-key="id"
            class="elevation-1 table table-striped tb-variants"
            :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-arrow-collapse-left',
                lastIcon: 'mdi-arrow-collapse-right',
                prevIcon: 'mdi-minus',
                nextIcon: 'mdi-plus'
            }"
        >
            <thead>
                <tr style="background-color:#f0f0f0;">
                    <th>Mutation Type</th>

                    <th>Genome Location <div v-html="this.$store.getters.getProcessState('load-genompos')"></div>
                    <!--</th>

                    <th @click="sortList('UTA_Adapter','gene_name',null)" style="padding:0;" class="tb-variants-col">
                    -->
                            <table class="" style="margin:0;padding:10px;width:100%;height:100%;"><tr><td>
                            Gene
                            </td><td>
                            <span style="padding-left:10px;"><v-icon icon="mdi-comment-alert-outline" />
                                <v-tooltip activator="parent" location="top">
                                HGNC gene symbol
                                </v-tooltip>
                            </span>
                            </td><td>
                            <span><v-icon :icon="this.iconStatesUp['UTA_Adapter_gene_name']" /></span>
                            <span><v-icon :icon="this.iconStatesDn['UTA_Adapter_gene_name']" /></span>
                            </td></tr>
                            <tr><td>
                            <div v-html="this.$store.getters.getProcessState('load-gene-name')"></div>
                            </td></tr>

                            <tr><td>
                                Protein Change
                                </td>
                                <td>
                                    <span style="padding-left:10px;">
                                        <v-icon icon="mdi-comment-alert-outline" />
                                        <v-tooltip activator="parent" location="top">
                                        </v-tooltip>
                                    </span>
                                </td>
                                <td>
                                    <span><v-icon :icon="this.iconStatesUp['UTA_Adapter_variant_exchange']" /></span>
                                    <span><v-icon :icon="this.iconStatesDn['UTA_Adapter_variant_exchange']" /></span>
                                </td>
                                </tr>

                            </table>
                    </th>

                    <th v-if="this.$store.getters.activeSNVColumns.includes('allele_frequency')">
                        Allele Frequency
                    </th>

                    <!--<th @click="sortList('UTA_Adapter','variant_exchange',null)" class="tb-variants-col">
                        <table class="" style="margin:0;padding:10px;width:100%;height:100%;">
                            <tr>

                            </tr>
                            <tr>
                                <td>
                                    <div v-html="this.$store.getters.getProcessState('load-variant-exchange')"></div>
                                </td>
                            </tr>
                        </table>
                    </th>-->

                    <!--<th>Functional Effect</th>-->

                    <th @click="sortList('dbsnp','total',null)" class="tb-variants-col" v-if="this.$store.getters.activeSNVColumns.includes('dbsnp')">
                        <table class="" style="margin:0;padding:10px;width:100%;height:100%;">
                            <tr>
                                <td>
                                    Frequency (dbSNP)
                                </td>
                                <td>
                                    <span style="padding-left:10px;">
                                        <v-icon icon="mdi-comment-alert-outline" />
                                        <v-tooltip activator="parent" location="top">
                                            Variant frequency in the population
                                        </v-tooltip>
                                    </span>
                                    <span><v-icon :icon="this.iconStatesUp['dbsnp_total']" /></span>
                                    <span><v-icon :icon="this.iconStatesDn['dbsnp_total']" /></span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div v-html="this.$store.getters.getProcessState('load-dbsnp')"></div>
                                </td>
                            </tr>
                        </table>
                    </th>

                    <th @click="sortList('clinvar','ClinicalSignificance',null)" class="tb-variants-col" style="text-align:center;">
                        <table class="" style="margin:0;padding:10px;width:100%;height:100%;">
                            <tr>
                                <td>
                                    ClinVar
                                </td>
                                <td>
                                    <span><v-icon icon="mdi-comment-alert-outline" />
                                        <v-tooltip activator="parent" location="top">
                                            Manually created pathogenicity estimations
                                        </v-tooltip>
                                    </span>
                                </td>
                                <td>
                                    <span><v-icon :icon="this.iconStatesUp['clinvar_ClinicalSignificance']" /></span>
                                    <span><v-icon :icon="this.iconStatesDn['clinvar_ClinicalSignificance']" /></span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div v-html="this.$store.getters.getProcessState('load-clinvar')"></div>
                                </td>
                            </tr>
                        </table>
                    </th>

                    <th @click="sortList('revel','Score',null)" class="tb-variants-col" style="text-align:center;">
                        <table class="" style="margin:0;padding:10px;width:100%;height:100%;">
                            <tr>
                                <td>
                                    REVEL
                                </td><td>
                                    <span><v-icon icon="mdi-comment-alert-outline" />
                                        <v-tooltip activator="parent" location="top">
                                        Pathogenicity Estimation of Rare Missense Variants [0=Benign, 1=Pathogenic]
                                        </v-tooltip>
                                    </span>
                                </td>
                                <td>
                                    <span><v-icon :icon="this.iconStatesUp['revel_score']" /></span>
                                    <span><v-icon :icon="this.iconStatesDn['revel_score']" /></span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div v-html="this.$store.getters.getProcessState('load-revel')"></div>
                                </td>
                            </tr>
                        </table>
                    </th>

                    <th @click="sortList('loftool','Score',null)" class="tb-variants-col" style="text-align:center;">
                        <table class="" style="margin:0;padding:10px;width:100%;height:100%;">
                            <tr>
                                <td>
                                    LoFTool
                                </td>
                                <td>
                                    <span><v-icon icon="mdi-comment-alert-outline" />
                                        <v-tooltip activator="parent" location="top">
                                        Gene Intolerance Score based on loss-of-function variants
                                        </v-tooltip>
                                    </span>
                                </td>
                                <td>
                                    <span><v-icon :icon="this.iconStatesUp['loftool_score']" /></span>
                                    <span><v-icon :icon="this.iconStatesDn['loftool_score']" /></span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div v-html="this.$store.getters.getProcessState('load-loftool')"></div>
                                </td>
                            </tr>
                        </table>
                    </th>

                    <th @click="sortList('vus_predict','Score',null)" class="tb-variants-col" style="text-align:center;">
                        <table class="" style="margin:0;padding:10px;width:100%;height:100%;">
                            <tr>
                                <td>
                                    VUS-Predict
                                </td>
                                <td>
                                    <span><v-icon icon="mdi-comment-alert-outline" />
                                        <v-tooltip activator="parent" location="top">
                                        Pathogenicity Estimation of Variants of Unknown Significance (VUS) [-1=Pathogenic, 1=Benign]
                                        </v-tooltip>
                                    </span>
                                </td>
                                <td>
                                    <span><v-icon :icon="this.iconStatesUp['vus_predict_score']" /></span>
                                    <span><v-icon :icon="this.iconStatesDn['vus_predict_score']" /></span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div v-html="this.$store.getters.getProcessState('load-vusp')"></div>
                                </td>
                            </tr>
                        </table>
                    </th>

                    <th @click="sortList('onkopus_aggregator','meta','total_number_of_results')"  class="tb-variants-col">
                        Interpretations
                        <table class="" style="margin:0;padding:10px;width:100%;height:100%;">
                            <tr>
                                <td>
                                    <span><v-icon icon="mdi-comment-alert-outline" />
                                        <v-tooltip activator="parent" location="top">
                                            Number of retrieved clinical interpretations of variants
                                        </v-tooltip>
                                    </span>
                                </td>
                                <td>
                                    <span><v-icon :icon="this.iconStatesUp['onkopus_aggregator_aggregated_evidence_data']" /></span>
                                    <span><v-icon :icon="this.iconStatesDn['onkopus_aggregator_aggregated_evidence_data']" /></span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div v-html="this.$store.getters.getProcessState('load-interpretations')"></div>
                                </td>
                            </tr>
                        </table>
                    </th>

                    <!--<th>OP
                        <span><v-icon icon="mdi-comment-alert-outline" />
                            <v-tooltip activator="parent" location="top">
                                Onkopus Pathogenicity
                            </v-tooltip>
                        </span>
                    </th>

                    <th>OCS
                        <span><v-icon icon="mdi-comment-alert-outline" />
                            <v-tooltip activator="parent" location="top">
                                Onkopus Clinical Significance
                            </v-tooltip>
                        </span>
                    </th>

                    <th>Score
                        <span><v-icon icon="mdi-comment-alert-outline" />
                            <v-tooltip activator="parent" location="top">
                                Onkopus Score
                            </v-tooltip>
                        </span>
                    </th>-->

                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,k) in this.$store.getters.id_snvs"  v-bind:key="k" :key="this.$store.getters.id_snvs">

                    <td>{{ item["variant_data"]["type"] }}</td>

                    <td>
                        <v-table>
                            <tr>
                                <td>{{ item["UTA_Adapter"]["gene_name"] }} :
                                {{ item["UTA_Adapter"]["variant_exchange"] }}</td>
                            </tr>
                            <tr>
                                <td>{{ item["variant_data"]["genomic_location"] }}</td>
                            </tr>
                        </v-table>
                    </td>

                    <td v-if="this.$store.getters.activeSNVColumns.includes('allele_frequency')">
                        {{ item["variant_data"]["info_features"]["AF"] }}
                    </td>

                    <td v-if="this.$store.getters.activeSNVColumns.includes('dbsnp')">
                        <v-table>
                        <tr><td>Frequency</td>
                        <td>{{ item["dbsnp"]["total"] }}</td></tr>
                        <tr><td>rsID</td><td>{{ item["dbsnp"]["rsID"] }}</td></tr>
                        </v-table>
                    </td>

                    <td>
                        <v-table>
                            <tr>
                                <td>
                                    <a href="">
                                        <v-chip
                                            class="ma-2"
                                            v-bind:color="this.getClinVarColor(item.clinvar.clinical_significance)"
                                            text-color="white"
                                        >
                                            {{ item["clinvar"]["clinical_significance"].replace('_',' ') }}
                                         </v-chip>
                                     </a>
                                </td>
                             </tr>
                             <tr>
                                <td><v-table><tr><td>
                                    <v-rating v-model="item.clinvar.score" class="ma-2" density="compact" color="blue-grey-lighten-1" length="4">
                                    </v-rating></td></tr><tr><td style="font-size: 10px;">
                                    {{ item["clinvar"]["review_status_label"] }}</td></tr></v-table>
                                </td>
                             </tr>
                             <tr>
                                <td style="font-size: 10px;">
                                    {{ item["clinvar"]["conflicting_clinical_significance_label"] }}
                                </td>
                             </tr>
                         </v-table>
                    </td>

                    <td>
                        <v-progress-linear v-model="item.revel.score_percent" color="#0097A7" height="25" :key="revel_key">
                                {{ item["revel"]["Score"] }}
                        </v-progress-linear>
                    </td>

                    <td>
                        <v-progress-linear v-model="item.loftool.score_percent" color="#0097A7" height="25" :key="revel_key">
                                {{ item["loftool"]["Score"] }}
                        </v-progress-linear>
                    </td>

                    <td>
                        <div style="width:100%;position:relative;">
                                    <table style="width:100%;"><tr>
                                    <td style="text-align:left;width:40%;padding:0;margin:0;">
                                        <div style="width:100%;text-align:left;">
                                        <v-progress-linear style="transform:rotate(180deg) translate(50%);"
                                        v-model="item.vus_predict.score_percent_1of2" color="#0097A7" height="25" :key="revel_key">
                                        </v-progress-linear></div></td>
                                        <td style="width:40%;">
                                        <div style="width:100%;">
                                        <v-progress-linear  v-model="item.vus_predict.score_percent_2of2" color="#AED581" height="25" :key="revel_key">
                                        </v-progress-linear></div>

                                        </td></tr></table>
                                        <div style="margin:0;padding:0;position:absolute;top:0px;text-align:center;left:45%;height:25px;">{{ item["vus_predict"]["Score"] }}</div>
                                    </div>
                    </td>

                    <td>{{ item["onkopus_aggregator"]["meta"]["total_number_of_results"] }}</td>
                    <!--<td></td>
                    <td></td>
                    <td></td>-->

                    <td>
                        <router-link style="text-decoration:none;"
                            :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-variant-details-q/${ item['UTA_Adapter']['gene_name'] }:${ item['UTA_Adapter']['variant_exchange'] }`
                            }"
                            >
                                <v-btn>Details<v-icon icon="mdi-chevron-right" /></v-btn>
                        </router-link>
                    </td>
                </tr>
            </tbody>
        </v-table>
    </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import Results_Biomarkers from "@/components/query_result_components/Results_Biomarkers";
import variant_annotation from "@/methods/variant_annotation";
import variant_types from "@/methods/variant_types";

export default {
    data () {
      return {
        headers: [
        ],
        revel_key: 0,
        revel_colour:"#00b0d2",
        clinvar_rating: 0,
        agg_interpret_data: '',
        sortStates: {
            'UTA_Adapter_gene_name': 0,
            'UTA_Adapter_variant_exchange': 0,
            'dbsnp_total': 0,
            'clinvar_ClinicalSignificance': 0,
            'revel_score': 0,
            'loftool_score': 0,
            'vus_score': 0,
            'onkopus_aggregator_aggregated_evidence_data': 0
        },
        iconStatesUp: {
            'UTA_Adapter_gene_name': 'mdi-arrow-up-thin',
            'UTA_Adapter_variant_exchange': 'mdi-arrow-up-thin',
            'dbsnp_total': 'mdi-arrow-up-thin',
            'clinvar_ClinicalSignificance': 'mdi-arrow-up-thin',
            'revel_score': 'mdi-arrow-up-thin',
            'loftool_score': 'mdi-arrow-up-thin',
            'vus_score': 'mdi-arrow-up-thin',
            'onkopus_aggregator_aggregated_evidence_data': 'mdi-arrow-up-thin'
        },
        iconStatesDn: {
            'UTA_Adapter_gene_name': 'mdi-arrow-down-thin',
            'UTA_Adapter_variant_exchange': 'mdi-arrow-down-thin',
            'dbsnp_total': 'mdi-arrow-down-thin',
            'clinvar_ClinicalSignificance': 'mdi-arrow-down-thin',
            'revel_score': 'mdi-arrow-down-thin',
            'loftool_score': 'mdi-arrow-down-thin',
            'vus_score': 'mdi-arrow-down-thin',
            'onkopus_aggregator_aggregated_evidence_data': 'mdi-arrow-down-thin'
        },
        columns: ['dbsnp','clinvar']
      }
    },
    components: {
    },
    created: async function() {
        //this.generateColumns()
    },
    methods: {
        generateColumns() {
            let columns = []

            if (this.$route.query.columns) {
            } else {
                for (let key in this.$store.getters.snvs) {
                    if ((JSON.stringify(this.$store.getters.snvs[key]["variant_data"]["info_features"]["AF"]) === '{}') == false) {
                        if (columns.includes("allele_frequency") == false) {
                            columns.push("allele_frequency")
                            //alert(this.$store.getters.snvs[key]["variant_data"]["info_features"]["AF"])
                        }
                    }
                    //alert(JSON.stringify(this.$store.getters.snvs[key]["dbsnp"]["total"]))
                    if ((JSON.stringify(this.$store.getters.snvs[key]["dbsnp"]["total"]) === '') == false) {
                        //alert("add")
                        if (columns.includes("dbsnp") == false) {
                            columns.push("dbsnp")
                        }
                    }
                }
            }
            this.$store.dispatch("setActiveSNVColumns",columns)
            alert(columns)
        },
        generateGeneNameLocations() {
            for (let key in this.$store.getters.getVariants) {
                let gene_name = this.$store.getters.getVariants[key]["UTA_Adapter"]["gene_name"] + ":" + this.$store.getters.getVariants[key]["UTA_Adapter"]["variant_exchange"]
                this.$store.dispatch('setGeneNameLoc',[gene_name,key])
                //alert(gene_name + ":" +key)
            }
        },
        rerender() {
        },
        getClinVarColor(estim) {
            if (estim =='') {
                return "white"
            }
            else if (estim == 'Benign/Likely benign') {
                return "#AED581"
            }
            else if (estim == 'Likely pathogenic') {
                return "#0097A7"
            }
            else if (estim == 'Pathogenic/Likely pathogenic') {
                return "#00838F"
            }
            else if (estim == 'Pathogenic| drug response| other') {
                return "#006064"
            }
            else if (estim == 'Conflicting interpretations of pathogenicity') {
                return "#78909C"
            } else {
                return "#ECEFF1"
            }
        },
        getBarColour(val) {
            //alert(val)
            if (val < 50) {
                return "#00b0d2"
            } else {
                return "#ce8585"
            }
        },
        showLoadingSpinner() {
        },
        isFusionQuery(q) {
            //alert("check fusion "+q)
            /*if (q) {
                const fusionExp = '(chr[0-9|X|Y]+:[0-9]+)-(chr[0-9|X|Y]+:[0-9]+)'
                const isMatch = q.match(fusionExp)
                //alert(isMatch)
                if (isMatch) {
                    //alert("match")
                    this.$router.push({ path: '/upload/fusion-q', query: { q: q } })
                }
            }*/
        },
        sortList(module,key,key1) {
            let data = this.$store.getters.snvs

            if (key1 == null) {
                if (this.sortStates[key] == 0) {
                    // des
                    this.isLoading = true
                    let sorted_new = Object.keys(data).sort( (x,y) => data[x][module][key] > data[y][module][key] ? -1 : 1).map(f => data[f] )
                    this.$store.dispatch('setSNVs',sorted_new)
                    this.sortStates[key] = 1

                    for (let k in this.iconStatesUp) {
                        this.iconStatesUp[k] = 'mdi-arrow-up-thin'
                    }
                    for (let k in this.iconStatesDn) {
                        this.iconStatesDn[k] = 'mdi-arrow-down-thin'
                    }

                    this.iconStatesDn[module + "_" + key]= 'mdi-arrow-down-bold-box'
                    this.iconStatesUp[module + "_" + key]= 'mdi-arrow-up-thin'
                    this.isLoading = false
                } else {
                    // asc
                    this.isLoading = true
                    let sorted_new = Object.keys(data).sort( (x,y) => data[x][module][key] < data[y][module][key] ? -1 : 1).map(f => data[f] )
                    this.$store.dispatch('setSNVs',sorted_new)
                    this.sortStates[key] = 0

                    for (let k in this.iconStatesUp) {
                        this.iconStatesUp[k] = 'mdi-arrow-up-thin'
                    }
                    for (let k in this.iconStatesDn) {
                        this.iconStatesDn[k] = 'mdi-arrow-down-thin'
                    }

                    this.iconStatesUp[module + "_" + key]= 'mdi-arrow-up-bold-box'
                    this.iconStatesDn[module + "_" + key]= 'mdi-arrow-down-thin'
                    this.isLoading = false
                }

            } else {
                if (this.sortStates[key] == 0) {
                    this.isLoading = true
                    let sorted_new = Object.keys(data).sort( (x,y) => data[x][module][key][key1] > data[y][module][key][key1] ? -1 : 1).map(f => data[f] )
                    this.$store.dispatch('setSNVs',sorted_new)
                    this.sortStates[key] = 1

                    for (let k in this.iconStatesUp) {
                        this.iconStatesUp[k] = 'mdi-arrow-up-thin'
                    }
                    for (let k in this.iconStatesDn) {
                        this.iconStatesDn[k] = 'mdi-arrow-down-thin'
                    }

                    this.iconStatesDn[module + "_" + key]= 'mdi-arrow-down-bold-box'
                    this.iconStatesUp[module + "_" + key]= 'mdi-arrow-up-thin'
                    this.isLoading = false
                } else {
                    // asc
                    this.isLoading = true
                    let sorted_new = Object.keys(data).sort( (x,y) => data[x][module][key][key1] < data[y][module][key][key1] ? -1 : 1).map(f => data[f] )
                    this.$store.dispatch('setSNVs',sorted_new)
                    this.sortStates[key] = 0

                    for (let k in this.iconStatesUp) {
                        this.iconStatesUp[k] = 'mdi-arrow-up-thin'
                    }
                    for (let k in this.iconStatesDn) {
                        this.iconStatesDn[k] = 'mdi-arrow-down-thin'
                    }

                    this.iconStatesUp[module + "_" + key]= 'mdi-arrow-up-bold-box'
                    this.iconStatesDn[module + "_" + key]= 'mdi-arrow-down-thin'
                    this.isLoading = false
                }
            }


        },
    }
}
</script>
<style>
</style>
